import { SEARCH_PARAMS_PAGE_VIEW_OPTIONS, SearchArticleViewOptions } from "@/constants/ui"
import { ProductPriceContainerCtnrROV1 } from "@ub/pricing-client"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { cn } from "@/lib/utils"
import ProductCard from "@/components/product/ProductCard"
import ProductCardLandscape from "@/components/product/ProductCardLandscape"

export default function ProductCardWrapper(props: {
  productData: ReducedProductData
  effectivePrices: ProductPriceContainerCtnrROV1
  view: SearchArticleViewOptions | string
  cardVariant: string
  isB2B: boolean
  showEcoTax: boolean
  debugMode: boolean | undefined
  hideAddToBasket: boolean
  priceRequestLink: string
  isoLocale: string
  trackingList: string | undefined
  position: number | undefined
  mainProductId: string | undefined
  isRecommendation: boolean | undefined
  inStoryBlock: boolean | undefined
  ffSearchParamsEncrypted?: string
}) {
  return (
    <>
      {(props.cardVariant === "landscape" && (
        <div className="relative z-0 flex w-full flex-col overflow-hidden bg-white transition duration-200 ease-in-out hover:z-50 hover:scale-105 hover:rounded-sm">
          <ProductCardLandscape
            isoLocale={props.isoLocale}
            productData={props.productData}
            prices={props.effectivePrices}
            showDescription={true}
            isB2BCustomer={props.isB2B}
            inStoryBlok={props.inStoryBlock ?? false}
            ffSearchParamsEncrypted={props.ffSearchParamsEncrypted}
          />
        </div>
      )) || (
        <div
          className={cn(
            "relative flex size-full flex-col overflow-hidden rounded-lg border border-gray-300 bg-white transition duration-200 ease-in-out 3xl:max-w-[25rem]",
            {
              "3xl:max-w-full": props.view === SEARCH_PARAMS_PAGE_VIEW_OPTIONS[1],
            }
          )}
        >
          <ProductCard
            isoLocale={props.isoLocale}
            productData={props.productData}
            prices={props.effectivePrices}
            showDescription={true}
            showEcoTaxFlag={props.showEcoTax}
            debugMode={props.debugMode}
            hideAddToBasket={props.hideAddToBasket}
            isB2BCustomer={props.isB2B}
            trackingList={props.trackingList}
            position={props.position}
            priceRequestLink={props.priceRequestLink}
            view={props.view}
            mainProductId={props.mainProductId}
            isRecommendation={props.isRecommendation}
            ffSearchParamsEncrypted={props.ffSearchParamsEncrypted}
            compact={false}
          />
        </div>
      )}
    </>
  )
}
